import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import { SettingsChoiceRow } from 'pages/pga-coach/settings/settings-components'
import useSettingsStyles from 'pages/pga-coach/settings/settings.styles'

// The settings "Student cancellations" rows without the card header.
export default function ChoiceRows({ options, value, labelledBy, onChange }) {
  const settingsClasses = useSettingsStyles()

  return (
    <Box
      className={settingsClasses.card}
      role="group"
      aria-labelledby={labelledBy}
    >
      <Box className={settingsClasses.cardBody}>
        {options.map(({ value: optionValue, icon: Icon, ...option }) => (
          <SettingsChoiceRow
            key={optionValue}
            {...option}
            icon={<Icon />}
            checked={optionValue === value}
            onSelect={() => onChange(optionValue)}
            classes={settingsClasses}
          />
        ))}
      </Box>
    </Box>
  )
}

ChoiceRows.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      icon: PropTypes.elementType.isRequired,
    }),
  ).isRequired,
  value: PropTypes.string.isRequired,
  labelledBy: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}
